/**
 * Hook for managing payment instruments
 */
import { useCallback } from 'react';
export function usePaymentInstruments({ basisTheory, paymentsResource, setError, }) {
    // Create card payment instrument
    const createCardPaymentInstrument = useCallback((cardData) => {
        return paymentsResource.createCardPaymentInstrument(basisTheory, cardData);
    }, [basisTheory, paymentsResource]);
    // Create Apple Pay payment instrument
    const createApplePayPaymentInstrument = useCallback((applePayToken) => {
        return paymentsResource.createApplePayPaymentInstrument(basisTheory, applePayToken);
    }, [basisTheory, paymentsResource]);
    // Create Google Pay payment instrument
    const createGooglePayPaymentInstrument = useCallback((googlePayToken) => {
        return paymentsResource.createGooglePayPaymentInstrument(basisTheory, googlePayToken);
    }, [basisTheory, paymentsResource]);
    // Get card payment instruments
    const getCardPaymentInstruments = useCallback(async () => {
        try {
            const response = await paymentsResource.getCardPaymentInstruments();
            return response;
        }
        catch (error) {
            const errorMsg = error instanceof Error ? error.message : 'Failed to fetch payment instruments';
            setError(errorMsg);
            throw error;
        }
    }, [paymentsResource, setError]);
    return {
        createCardPaymentInstrument,
        createApplePayPaymentInstrument,
        createGooglePayPaymentInstrument,
        getCardPaymentInstruments,
    };
}
